module.exports = __webpack_public_path__ + "static/media/step2_14.da785b3f.png";